import Box from '@liquidweb-dev/undercurrent/Box';
import Link from '@liquidweb-dev/undercurrent/Link';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import { useEffect, useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import SuspenseFallback from 'components/routers/RouteHandler/SuspenseFallback';
import { useBasketAdmin } from 'modules/oidc/useAuthenticated';
import { REDIRECT_PATH } from 'utility/constants/auth';

const FAILSAFE_MS = 3000; // 3 seconds

export function OidcCallback() {
	const { isLoading, error } = useAuth();
	const history = useHistory();
	const isBasketAdmin = useBasketAdmin();

	const isAuthReady = !isLoading && !error;
	const showLink = !isLoading || error;
	// Store the redirect path
	const redirectPath = useMemo(() => sessionStorage.getItem(REDIRECT_PATH), []);

	useEffect(() => {
		if (!isAuthReady) return;

		// Use the redirect path
		if (redirectPath) {
			sessionStorage.removeItem(REDIRECT_PATH);
			history.replace(redirectPath || '/');
			return;
		}

		// Basket admins go to basket admin places
		if (isBasketAdmin) {
			history.replace('/shop/marketplace');
			return;
		}

		history.replace('/');
	}, [isAuthReady, redirectPath, isBasketAdmin, history]);

	// redirect anywhere after a time
	useEffect(() => {
		if (!isAuthReady) return undefined;

		const timer = setTimeout(() => {
			history.replace('/');
		}, FAILSAFE_MS);

		return () => {
			clearTimeout(timer);
		};
	}, [isAuthReady, history]);

	return (
		<Box sx={{ margin: 'auto' }}>
			<SuspenseFallback />

			<Stack
				sx={{
					paddingTop: 200,
					textAlign: 'center',
					typography: 'body-md',
					gap: 100,
				}}
			>
				<div>You are being redirected.</div>
				{showLink && (
					<Link component={RouterLink} to="/">
						Click here if not redirected automatically
					</Link>
				)}
			</Stack>
		</Box>
	);
}

export default OidcCallback;
